<div class="simple-table__location-search">
  <input [formControl]="searchControl" class="simple-table__filter--search" [placeholder]="placeholder || translateData['search_location_placeholder'] || 'Search location...'"
    [attr.aria-label]="translateData['aria_search_location'] || 'Search location'" [value]="searchControl || ''" />
</div>

@if (hasResults()) {
<div class="simple-table__location-results">
  <div class="simple-table__location-item">
    <label class="simple-table__label-checkbox simple-table__label-checkbox--all">
      <input #selectAllBox type="checkbox" [checked]="isAllSelected()"
        (change)="onToggleSelectAll(selectAllBox.checked)" [attr.aria-label]="translateData['aria_select_all_locations'] || 'Select all locations'" />
      {{ translateData['select_all'] || '(Select All)' }}
    </label>
  </div>
  @if (locationResults.territories.length) {
  @for (item of locationResults.territories; track trackByFn($index, item)) {
  <div class="simple-table__location-item">
    <label class="simple-table__label-checkbox">
      <input type="checkbox" [id]="idFor('territory', item)" data-type="territories" [value]="item"
        (change)="onCheckboxChange($event, 'territories', item)" [checked]="isSelected('territories', item)" />
      {{ item }}
    </label>
  </div>
  }
  }
  @if (locationResults.division.length) {
  @for (item of locationResults.division; track trackByFn($index, item)) {
  <div class="simple-table__location-item">
    <label class="simple-table__label-checkbox">
      <input type="checkbox" [id]="idFor('division', item)" data-type="division" [value]="item"
        (change)="onCheckboxChange($event, 'division', item)" [checked]="isSelected('division', item)" />
      {{ item }}
    </label>
  </div>
  }
  }
  @if (locationResults.municipality.length) {
  @for (item of locationResults.municipality; track trackByFn($index, item)) {
  <div class="simple-table__location-item">
    <label class="simple-table__label-checkbox">
      <input type="checkbox" [id]="idFor('municipality', item)" data-type="municipality" [value]="item"
        (change)="onCheckboxChange($event, 'municipality', item)" [checked]="isSelected('municipality', item)" />
      {{ item }}
    </label>
  </div>
  }
  }
</div>
} @else {
<div class="simple-table__location-results">
  <span class="simple-table__no-results">{{ translateData['no_results_found'] || 'No results found.' }}</span>
</div>
}